import Index from '../components/Layout/Index/Index'
import GeneralStatisticsAll from '../components/containers/GeneralStatisticsAll/GeneralStatisticsAll'
import GeneralStatisticsOne from '../components/containers/GeneralStatisticsOne/GeneralStatisticsOne'
import OrganizationList from '../components/containers/OrganizationList/OrganizationList'
import DiseasedPeriod from '../components/containers/Diseased/Period'
import Candidates from '../components/containers/Сandidates'
import DiseasedCovid from '../components/containers/Diseased/Covid'
import StudentsTotal from '../components/containers/StudentsTotal'
import { CasesNumber } from '../components/containers/CasesNumber'
import { FileSharing } from '../components/containers/FileSharing'
import Phonebook from '../components/containers/Phonebook/Phonebook'
import Vaccinated from '../components/containers/Vaccinated/Vaccinated'
import Duplicates from '../components/containers/Duplicates/Duplicates'
import ConnectionFails from '../components/containers/ConnectionFails/ConnectionFails'
import CandidatesCons from '../components/containers/СandidatesCons'
import Privileges from '../components/containers/Privileges'
import Graduates from '../components/containers/Graduates'
import GraduatesHEO from '../components/containers/GraduatesHEO'
import GraduateOrientation from '../components/containers/GraduateOrientation'
import SummGraduateOrientation from '../components/containers/SummGraduateOrientation'
import SummGraduatesHEO from '../components/containers/SummGraduatesHEO'
import GIA from '../components/containers/GIA'
import Commission from '../components/containers/Commission'
import HiringPlan from '../components/containers/HiringPlan'
import StaffInfo from '../components/containers/StaffInfo'
import Performance from '../components/containers/Performance'
import StudentsInfo from '../components/containers/StudentsInfo'
import Applicants from '../components/containers/Applicants'

export const menuStructure = [
  {
    title: 'Главная',
    link: '/',
    path: '/',
    access: true,
    component: Index,
  },
  {
    title: 'Отчёты',
    link: '/reports',
    path: '/reports',
    access: true,
    component: Index,
    dropdown: [
      {
        title: 'Показатели оценки довузовских общеобразовательных организаций (общий)',
        link: '/reports/general_statistic_all',
        path: '/reports/general_statistic_all',
        access: false,
        component: GeneralStatisticsAll,
      },
      {
        title: 'Показатели оценки довузовских общеобразовательных организаций',
        link: '/reports/general_statistic_one/',
        path: '/reports/general_statistic_one/:id?',
        access: false,
        component: GeneralStatisticsOne,
      },
      {
        title: 'Объемные показатели по определению лучшего училища',
        link: '/reports/best_school?authorized',
        path: null,
        access: true,
        component: null,
        // blank: true,
      },
      {
        title: 'Сведения о заболевших на дату',
        link: '/reports/diseased_period',
        path: '/reports/diseased_period',
        access: false,
        component: DiseasedPeriod,
      },
      {
        title: 'Статистика по заболевшим COVID-19',
        link: '/reports/diseased_covid',
        path: '/reports/diseased_covid',
        access: false,
        component: DiseasedCovid,
      },
      {
        title: 'Статистика по вакцинации от COVID-19',
        link: '/reports/vaccinated_covid',
        path: '/reports/vaccinated_covid',
        access: false,
        component: Vaccinated,
      },
      {
        title: 'Кандидаты на поступление по субъектам РФ',
        link: '/reports/candidates',
        path: '/reports/candidates',
        access: false,
        component: Candidates,
      },
      {
        title: 'Численность переменного состава',
        link: '/reports/students_total',
        path: '/reports/students_total',
        access: false,
        component: StudentsTotal,
      },
      {
        title: 'Количество личных дел кандидатов на поступление',
        link: '/reports/cases_number',
        path: '/reports/cases_number',
        access: false,
        component: CasesNumber,
      },
      {
        title: 'Телефонный справочник руководящего состава училищ',
        link: '/reports/phonebook',
        path: '/reports/phonebook',
        access: false,
        component: Phonebook,
      },
      {
        title: 'Отчет по двойникам из числа кандидатов на поступление',
        link: '/reports/duplicates',
        path: '/reports/duplicates',
        access: false,
        component: Duplicates,
      },
      {
        title: 'Количество сбоев при подключении к базам данных',
        link: '/reports/connect_fails',
        path: '/reports/connect_fails',
        access: false,
        component: ConnectionFails,
      },
      {
        title: 'Кандидаты на поступление по субъектам РФ (сводный)',
        link: '/reports/candidates_cons',
        path: '/reports/candidates_cons',
        access: false,
        component: CandidatesCons,
      },
      {
        title: 'Отчет по льготам переменного состава',
        link: '/reports/privileges',
        path: '/reports/privileges',
        access: false,
        component: Privileges,
      },
      {
        title: 'Отчёт о поступлении выпускников',
        link: '/reports/graduates',
        path: '/reports/graduates',
        access: false,
        component: Graduates,
      },
      {
        title: 'Сведения о мероприятиях военно-профессиональной ориентации выпускников',
        link: '/reports/graduate_orientation',
        path: '/reports/graduate_orientation',
        access: false,
        component: GraduateOrientation,
      },
      {
        title: 'Список выпускников, поступающих в военные вузы',
        link: '/reports/graduate_heo',
        path: '/reports/graduate_heo',
        access: false,
        component: GraduatesHEO,
      },
      {
        title: 'Сводная таблица по выпускникам, поступающим в вузы',
        link: '/reports/summ_graduate_heo',
        path: '/reports/summ_graduate_heo',
        access: false,
        component: SummGraduatesHEO,
      },
      {
        title: 'Сводная таблица по мероприятиям профориентации',
        link: '/reports/summ_graduate_orientation',
        path: '/reports/summ_graduate_orientation',
        access: false,
        component: SummGraduateOrientation,
      },
      {
        title: 'Сведения о результатах сдачи ГИА (форма 1/СВУ)',
        link: '/reports/gia',
        path: '/reports/gia',
        access: false,
        component: GIA,
      },
      {
        title: 'Предложения по организации набора на вакантные места',
        link: '/reports/hiring_plan',
        path: '/reports/hiring_plan',
        access: false,
        component: HiringPlan,
      },
      {
        title: 'Сведения об успеваемости и качестве учебы (форма №2/СВУ)',
        link: '/reports/performance',
        path: '/reports/performance',
        access: false,
        component: Performance,
      },
      {
        title: 'Сведения о работниках (форма №3/СВУ)',
        link: '/reports/staff_info',
        path: '/reports/staff_info',
        access: false,
        component: StaffInfo,
      },
      {
        title: 'Сведения об обучающихся (форма №4/СВУ)',
        link: '/reports/students_info',
        path: '/reports/students_info',
        access: false,
        component: StudentsInfo,
      },
    ],
  },
  {
    title: 'Справочники',
    link: '/publishers',
    path: '/publishers',
    access: true,
    component: Index,
    dropdown: [
      {
        title: 'Организации',
        link: '/organization',
        path: '/organization',
        access: true,
        component: OrganizationList,
      },
      {
        title: 'Комиссии',
        link: '/commissions',
        path: '/commissions',
        access: true,
        component: Commission.List,
      },
      {
        title: 'Комиссия',
        path: '/commissions/:id',
        access: true,
        component: Commission.Current,
        hidden: true,
      },
      {
        title: 'Заявки на поступление',
        link: '/applicants',
        path: '/applicants',
        access: false,
        component: Applicants,
      },
    ],
  },
  {
    title: 'Обмен файлами',
    link: '/file_sharing',
    path: '/file_sharing',
    access: false,
    component: FileSharing,
  },
]
